import clsx from "clsx";
import { Form } from "react-bootstrap";
import styles from "./compare-samples.module.scss";

interface CompareToolbarProps {
  differenceCount: number;
  fieldCount: number;
  onlyDifferences: boolean;
  onOnlyDifferencesChange: (onlyDifferences: boolean) => void;
}

const CompareToolbar = ({
  differenceCount,
  fieldCount,
  onlyDifferences,
  onOnlyDifferencesChange
}: CompareToolbarProps): JSX.Element => (
  <div className={styles.toolbar}>
    <div>
      <b>
        {differenceCount} of {fieldCount}
      </b>{" "}
      compared fields differ
    </div>
    <div className={styles["toolbar-right"]}>
      <div className={styles.legend}>
        <span className={styles["legend-item"]}>
          <span className={styles.chip}>&nbsp;</span>
          <span>In both</span>
        </span>
        <span className={styles["legend-item"]}>
          <span className={clsx(styles.chip, styles["chip--unique"])}>
            &minus;
          </span>
          <span>Only on the main sample</span>
        </span>
        <span className={styles["legend-item"]}>
          <span className={clsx(styles.chip, styles["chip--unique"])}>+</span>
          <span>Only on the compared sample</span>
        </span>
      </div>
      <Form.Check
        type="switch"
        id="compare-samples-only-differences"
        label="Only show differences"
        data-testid="compare-samples-only-differences"
        checked={onlyDifferences}
        onChange={() => onOnlyDifferencesChange(!onlyDifferences)}
      />
    </div>
  </div>
);

export default CompareToolbar;
